export default __webpack_public_path__ + "static/media/meals.d68bc1df.png";